import { Gamepad2, Globe, Heart, ShieldCheck, Smartphone, Zap } from "lucide-react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AboutFirst = () => {

 useEffect(() => {
  let aosInstance;

  import("aos").then((AOS) => {
    aosInstance = AOS.default;
    aosInstance.init({
      duration: 500,
      once: true,
      offset: 80,
      easing: "ease-out-cubic",
    });
  });

  return () => {
    aosInstance && aosInstance.refreshHard();
  };
}, []);


  return (
    <section
      className="relative bg-gradient-to-b from-[#0b1120] to-[#1a1f35] pb-11 lg:px-8 text-white sm:pt-[130px] pt-[110px]">
      <div className="container mx-auto px-4 ">
        <h1
          className="text-center text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold mb-8"
          data-aos="fade-down"
        >
          About{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
           Game Zone Hub
          </span>
        </h1>   

        {/* 🚀 NATURAL & ENGAGING INTRODUCTION FOR LOW CONTENT QUALITY FIX */}
        <div className="max-w-5xl mx-auto text-center md:mb-20 mb-14" data-aos="fade-up" data-aos-delay="100">
            <p className="text-[16px] md:text-lg text-gray-300 leading-relaxed mb-6">
              Welcome to <strong className="text-blue-400">Game Zone Hub</strong>. We built this platform with one simple idea in mind: playing games online should be easy, fast, and completely free. We are a team of gamers and developers who got tired of searching the web for good games, only to be met with forced downloads, slow loading times, or hidden fees.
            </p>
            <p className="text-[16px] md:text-lg text-gray-400 leading-relaxed mb-6">
              That is why we decided to create our own space. By focusing on modern HTML5 <strong>browser games</strong>, we ensure that whether you want to race cars, solve puzzles, or battle other players, you can jump straight into the action directly from your web browser. It does not matter if you are on a high-end PC or a five-year-old smartphone; if you have a web browser, you can play here.
            </p>
            <div className="inline-block bg-blue-900/30 border border-blue-500/30 rounded-2xl p-4 mt-2">
                <p className="text-[16px] md:text-lg text-cyan-100 leading-relaxed font-semibold">
                No apps to install. No accounts to create. No credit cards. Just click and play.
                </p>
            </div>
        </div>

        <ul
          className="grid text-center lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-8 md:mt-10 sm:mt-8 mt-6"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <li data-aos="zoom-in-up" data-aos-delay="100" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-blue-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-blue-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-500/20 group-hover:rotate-6 transition-all duration-300">
                 <Gamepad2 className="w-10 h-10 text-blue-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Always Free</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                We sustain our site through light, unintrusive advertising. This means you get full access to every single game in our massive library without ever hitting a paywall.
              </p>
            </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="200" className="h-full">
             <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-yellow-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
               <div className="bg-yellow-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-yellow-500/20 group-hover:scale-110 transition-all duration-300">
                 <Zap className="w-10 h-10 text-yellow-400" />
              </div>
               <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Fast Loading</h3>
               <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                 Nobody likes to wait. Our games use optimized web technologies to load almost instantly, so you can spend your time actually playing instead of staring at a loading bar.
               </p>
             </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="300" className="h-full">
           <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-green-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
             <div className="bg-green-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-green-500/20 group-hover:-rotate-6 transition-all duration-300">
                <ShieldCheck className="w-10 h-10 text-green-400" />
             </div>
             <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Safe & Secure</h3>
             <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
               By playing games right in your browser, you avoid the risk of accidentally downloading viruses or malware to your computer or phone. It is a clean, safe environment.
             </p>
           </div>
          </li>
          
          <li data-aos="zoom-in-up" data-aos-delay="400" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6  h-full rounded-3xl shadow-xl border border-white/5 hover:border-purple-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-purple-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-500/20 group-hover:scale-110 transition-all duration-300">
                 <Smartphone className="w-10 h-10 text-purple-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Play on Any Device</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                Our site is responsive. Whether you are using a mouse on a PC or swiping on an iPad, the games automatically adjust to give you the best possible control and view.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="500" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6 h-full rounded-3xl shadow-xl border border-white/5 hover:border-pink-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-pink-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-pink-500/20 group-hover:scale-110 transition-all duration-300">
                 <Heart className="w-10 h-10 text-pink-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Hand-Picked Games</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                We test everything before it goes live. If a game is boring, broken, or full of annoying pop-ups, we don't host it. You only get to play the good stuff.
              </p>
            </div>
          </li>

          <li data-aos="zoom-in-up" data-aos-delay="600" className="h-full">
            <div className="bg-[#1e293b] sm:p-8 p-6  h-full rounded-3xl shadow-xl border border-white/5 hover:border-cyan-500/40 hover:scale-105 transition-all duration-300 group flex flex-col">
              <div className="bg-cyan-500/10 w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-cyan-500/20 group-hover:rotate-12 transition-all duration-300">
                 <Globe className="w-10 h-10 text-cyan-400" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Everyone Welcome</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed flex-grow">
                From little kids playing coloring games to adults competing in intense multiplayer battles, Game Zone Hub is built to be a fun, welcoming space for everyone.
              </p>
            </div>
          </li>
          
        </ul>
        
        {/* 🚀 NATURAL VISION SECTION */}
        <div className="sm:mt-20 mt-12 max-w-5xl mx-auto bg-[#1e293b] sm:p-8  p-6  rounded-3xl border border-white/10 text-center shadow-2xl relative overflow-hidden" data-aos="fade-up">
            <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 pointer-events-none"></div>
            
            <h2 className="text-3xl md:text-4xl font-extrabold mb-8 text-white relative z-10">Our Mission</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-purple-400 mx-auto rounded-full mb-8 relative z-10"></div>
            
            <p className="text-cyan-100 text-lg sm:text-xl font-medium leading-relaxed mb-6 italic relative z-10">
                "We want to be the easiest place on the internet to play a game. No friction, no stress, just instant fun for anyone with a web browser."
            </p>
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed relative z-10">
                We are always adding new games and listening to what our players want. As web technology keeps getting better, we will keep working hard to make sure Game Zone Hub remains the best place to find your next digital adventure.
            </p>
        </div>

        <div
          className="sm:mt-20 mt-10 text-center sm:pb-10"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <h3
            className="sm:text-3xl text-2xl font-extrabold text-white mb-8"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            Ready to find your new favorite game?
          </h3>
          <Link
            to="/games"
            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 text-white sm:px-10 px-5 py-3 rounded-full sm:text-lg text-[16px] font-bold shadow-[0_0_25px_rgba(59,130,246,0.6)] hover:shadow-[0_0_40px_rgba(59,130,246,0.8)] transition-all duration-300 transform hover:scale-105"
            data-aos="fade-up"
            data-aos-delay="500"
            aria-label="Play Free Online Games Now"
          >
            <Gamepad2 className="w-6 h-6" /> Explore Our Games
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutFirst;